import IImportation from "@/interfaces/importation.interface";
import { ImportationsFiltersMessages } from "@/messages/importations/importations-filter.messages";
import { ImportationsTableMessages } from "@/messages/importations/importations-table.messages";
import { FilterAttributes, FilterType, FilterValue, IFilter } from "@/types/filter.types";
import { SelectData } from "@/types/form.types";

import { ImportationFilterKey } from "./types";

export const IMPORTATIONS_TABLE_COLUMNS = (messages: ImportationsTableMessages) => {
  return [
    messages.dateColumn,
    messages.typeColumn,
    messages.fileNameColumn,
    messages.statusColumn,
    messages.successColumn,
    messages.errorColumn,
    messages.optionsColumn,
  ];
};

export const IMPORTATIONS_FILTER_OPTIONS = (
  messages: ImportationsFiltersMessages
): SelectData<ImportationFilterKey>[] => [
  { label: messages.allOption, value: "all" },
  { label: messages.dateOption, value: "rowDate" },
  { label: messages.typeOption, value: "sourceType" },
  { label: messages.fileNameOption, value: "mediaName" },
  { label: messages.statusOption, value: "status" },
];

export const IMPORTATIONS_FILTER_ATTRIBUTES: Partial<
  Record<ImportationFilterKey, FilterAttributes>
> = {
  all: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "disable",
  },
  rowDate: {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "date",
  },
  sourceType: {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "options",
  },
  mediaName: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  status: {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "options",
  },
};

export const IMPORTATIONS_FILTER_OPTION_VALUES = (
  messages: ImportationsFiltersMessages
): Partial<Record<ImportationFilterKey, SelectData<FilterValue>[]>> => ({
  sourceType: [
    { value: "CONTACT", label: messages.contactOption },
    { value: "PRODUCT", label: messages.productOption },
  ],
  status: [
    { value: "PENDING", label: messages.pendingOption },
    { value: "PROCESSING", label: messages.processingOption },
    { value: "COMPLETED", label: messages.completedOption },
    { value: "ERROR", label: messages.errorOption },
  ],
});

export const initialFilterValues: IFilter<IImportation>[] = [
  {
    property: "mediaName",
    value: "",
    filterType: FilterType.Contains,
  },
];
